module.exports = __webpack_public_path__ + "img/GNT-alt.bea5b6c7.svg";